export default {
  application: {
    applicationScreenTitle: {
      reviewString: 'Please review your profile info.',
      customerServiceString:
        'If you need to make an update, give us a call at ',
      cardApplication: 'Card application',
      believeApplication: 'Believe application',
      reviewInfoHeader: 'Review your information',
      reviewInfoDetails:
        'We’ll send your Believe Card to the address listed below. If you need to make changes, update your information in My Varo.',
      termsSectionDivider: 'Terms of Service',
    },
    addressReview: {
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      address: 'Address',
    },
    agreements: {
      believeProgramAgreements: {
        firstPart: 'I agree and acknowledge receipt of the',
        linkText: 'Varo Believe Program Agreements',
        secondPart:
          'and authorize Varo to pull my credit report for this application. This does not affect your credit score.',
      },
      obtainInformation:
        'I confirm my written instructions to Varo authorizing Varo to obtain information from my personal credit profile from TransUnion. I authorize Varo to obtain such information solely to confirm my identity and display my credit data to me.',
      grantInterest:
        'I confirm and agree that as a condition of the Varo Believe Program, I grant Varo a security interest in my Varo Bank and Savings Accounts.',
      safePay:
        'I agree to turn on Safe Pay. I want to use Safe Pay to take care of my monthly payments. (Optional)',
      agreeToAll: 'I agree to all',
      believeProgramAgreementsTitle: 'Believe Program Agreements',
    },
    error: {
      primaryButton: 'Ok',
      title: 'Your application was declined',
      subTitle:
        'Unfortunately, we couldn’t verify your information. We sent you an email with more details.',
    },
    submitApplication: 'Submit application',
    applicationSuccess: {
      bodyText: 'Your Believe card will arrive in about 1–2 weeks. ',
      captionText:
        'The Varo Believe Card is issued by Varo Bank, N.A. pursuant to a license from Visa USA, Inc.',
    },
    button: {
      done: 'Done',
    },
    makeCreditBuilding: {
      creditBuildingHeading: 'Make Credit-Building a breeze',
      varoBelieveCardText:
        'Meet the Varo Believe Card—the worry-free way to build credit.¹',
      noFeesText: 'No monthly fees, no interest, no minimum deposit.',
      creditScoreText: 'Applying won’t impact your credit.',
      thumbText:
        'On average, users see a 40+ point increase after three months of on-time payments.²',
      buildCreditText: ' Use your card. Help build your credit.',
      subscriptionText:
        'Coffee. Gas. Groceries. Subscriptions. Even bills. You can build credit with all the things you buy on the daily.',
      applyNow: 'Apply now',
      howToApply: 'How to apply',
      disclosure:
        '¹ Varo Believe is a secured credit card designed to help you build credit; however, a variety of factors impact your credit and not all factors are equally weighted. You must add money before using, money added sets the spending limit. Funds spent are held in your Varo Believe Secured Account to pay off any balance in full monthly, when due. Quals apply.\n\n² As of November 18, 2024, customers who had an existing VantageScore® 3.0 credit score showed an average increase of approximately 40 points after three months using Varo Believe and on time payments. Individual results may vary, and some customers may not see a score increase.',
    },
    moveMoney: {
      title: 'Just move money to start using Believe',
      bodyListBold_1: 'Move Money',
      bodyListNormal_1:
        '\nTransfer money from your Varo Bank Account to your Varo Believe Account. You can always move it back.',
      bodyListBold_2: 'Use your Believe card for spending',
      bodyListNormal_2:
        '\nThe money in your Believe Account is your spending limit, so your budget is built-in.',
      alertBodyText:
        'You can move money between your Believe Account and Bank Account anytime.',
      skipForNow: 'Skip for now',
      moveMoney: 'Move money',
    },
    approvedApplication: {
      skip: 'Skip',
      title: "You're approved! Your card is on it's way.",
      subtitle:
        'Your card should arrive in 7-10 business days. Add money to start spending with your virtual card.',
      fundInstantly: 'Fund instantly',
      spendingLimit: 'Set your own spending limit',
      moveMoney: 'Move money in and out of your Believe account at any time',
      addMoney: 'Add money',
      cardAccessibilityLabel: 'Varo Believe Card',
      disclosure:
        'Funding your Believe account with an external debit card is optional. You may also transfer directly from your Varo Bank on the home screen.\n\nBy continuing, you authorize a one-time debit from your external account. Varo will deposit these funds into your Varo Bank Account and immediately transfer to your Believe Secured Account to set your spending limit. If the debit is disputed, reversed, or charged back, Varo reserves the right to immediately debit your Believe Secured Account for the reversed amount.\n\nThe Varo Believe Card is issued by Varo Bank, N.A. pursuant to a license from Visa USA, Inc.',
    },
  },

  learningCenter: {
    title: 'Believe Card Basics',
    basicScreenOptions: {
      howWorks: 'How Varo Believe works',
      howBuildCredit: 'How to build credit',
      cardBenefits: 'Card benefits',
      spendingLimit: 'Spending limit',
      supportTopics: 'Support topics',
    },
    cardBenefits: {
      title: 'It’s not just a credit builder',
      description: 'With the Varo Believe Card, you can also:',
      bullets: {
        one: 'Earn up to 6% cashback.*',
        two: 'Get cash from ATMs.',
        three: 'Use it everywhere Visa is accepted.',
        four: 'Instantly lock your card in the app.',
        five: 'Get automatic account alerts.',
      },
      conditions:
        '*Individual offers may vary. Automatically get cash in your Varo Bank Account every time you reach $5 in cashback. Cashback available on specific items or services purchased with your Varo Debit Card and Varo Believe Card at select brands. Offer details may vary, see the Perks tab for more details and current deals. The maximum Cashback that can be earned is fifty dollars ($50 USD) per calendar month.',
    },
    spendingLimits: {
      title: 'You set the limit',
      description:
        'The money you add to your Believe Account is how much you can spend. ',
      inLineAlert: {
        title: '"Want to spend more?"',
        description:
          'Just add more money to your account! You can always move it back to your other Varo accounts if you don’t spend it, or you can take out cash.',
      },
    },
    howToBuildCredit: {
      safePayOffString: {
        screenLabel: `On-time payments are really important when building credit. We report your credit card payments to the credit bureaus.\n\nTurn on Safe Pay to automatically pay your monthly card balance.`,
      },
      safePayOnString: {
        stringOne:
          'On-time payments are really important when building credit.',
        stringTwo:
          'All you need to do? Use your card, then watch your credit score in the app.',
        bullets: {
          one: 'When Safe Pay is turned on, your card balance is paid automatically each month.',
          two: 'We report your monthly card payments to the credit bureaus to help you build credit history.',
        },
      },
      buildCreditTitleString: {
        screenLabel: 'Here’s the scoop',
      },
      snackBarString: {
        text: 'Safe Pay has been turned on.',
      },
      buttonString: {
        text: 'Turn on Safe Pay',
      },
    },
    howWorks: {
      title: 'Let’s look at an example',
      bottomSheet: {
        title: 'What if I don’t have Safe Pay on?',
        description:
          'If you choose to not turn on Safe Pay, you’ll need to remember to make on-time payments by your Statement due date each billing cycle. \n\nWith Safe Pay on, you don’t have to worry about making your payments. We’ve got you covered. \n\nJust turn on Safe Pay to automatically pay your monthly card balance.\n',
        primaryButton: 'Turn on Safe Pay',
      },
      linkSafePay: "What if I don't have Safe Pay on?",
      steps: {
        stepOne: {
          title: 'You add $100 to your Believe Account',
          description:
            'That’s your spending limit, so your budget is built-in.',
        },
        stepTwo: {
          title: 'You spend $30 at the grocery store',
          description:
            'You can use your Believe card anywhere Visa® is accepted. Nice!.',
        },
        stepThree: {
          title: 'Safe Pay automatically pays off your $30 card balance',
          description:
            'Safe Pay makes your monthly payment using the money you previously added to your Believe Account. ',
        },
        stepFour: {
          title: 'Watch your credit score',
          description:
            'Your payment history is reported to the major credit bureaus to help you improve your credit score.',
        },
      },
      linkText: 'What if I don’t have Safe Pay on?',
    },
  },
  creditBuildingDetails: {
    noActionNeeded:
      ' No action needed. Your purchases are covered automatically because you have',
    creditBureaus: ' We’ll share this activity with credit bureaus.',
    safePayOnText: 'Safe Pay on.',
    makePayment: 'Make payment',
    paymentHistory: 'Payment history',
    creditBuildingDetails: 'Credit building details',
    ok: 'OK',
  },
  safePayString: {
    headerTitle: 'Safe Pay',
    safePayText: 'Safe Pay',
    safePayOn:
      'Turn on Safe Pay to automatically pay your monthly statement balance on-time using the money set aside in your Varo Believe Account.',
    safePayOff:
      'Turn on Safe Pay to automatically pay your monthly statement balance on-time using the money set aside in your Varo Believe Account.',
    successMassage: 'Safe Pay has been turned on.',
    turnedOffMessage: 'Safe Pay has been turned off.',
  },
  actionPageString: {
    title: 'Your digital card is ready to use',
    addCard:
      'Add your Believe card to your digital wallet and transfer cash to your account to start spending.',
    addButton: 'Add to Apple Wallet',
    skipForNow: 'Skip for now',
    visaDisclaimer:
      'The Varo Believe Card is issued by Varo Bank, N.A. pursuant to a license from Visa USA, Inc.',
    skip: 'Skip',
  },
  paymentHistory: {
    screenHeader: 'Payment history',
    title: 'Varo Believe Card payment',
    scheduled: 'Scheduled',
    to: 'To',
    varoBankAccount: 'Varo Bank Account',
    reviewPageString: {
      title: 'We’re reviewing your application',
      subtitle:
        'Sit tight for now. Once we take a look and make a decision, we’ll send an email letting you know.',
      doneButton: 'Done',
    },
    emptyState: 'Your activity will be shown here.',
  },
  paymentHistoryDetails: {
    screenHeader: 'Transaction detail',
    cancelButton: 'Cancel payment',
    tryAgain: 'Try again',
    bottomSheet: {
      heading: 'Are you sure you want to cancel this payment?',
      description:
        'You will not be able to undo this action. To schedule a new payment, go to Pay Card.',
      bottomSheetCancelButton: 'Yes, cancel payment',
      bottomSheetBackButton: 'Go back to payment history',
    },
  },
  qualifyString: {
    title: 'How to qualify for Varo Believe',
    list: {
      one: 'Incoming deposits of $200 or more in the past 31 days',
      believeDay0One: 'Maintain a positive balance in your Varo Bank Account',
      two: 'Maintain a Varo Bank account with no negative balance and no overdue Varo Advance.',
      believeDay0Two: 'Have no overdue Varo Advance or Line of Credit',
      three: 'Additional qualifications apply.',
    },
    mainText:
      'To be eligible for the Varo Believe Card, you need to have received incoming deposits of $200 or more in the past 31 days to your Varo Bank Account and/or Savings Account. \n\nVaro Believe is a secured credit card designed to help you build credit; however, a variety of factors impact your credit and not all factors are equally weighted. Building credit may take time and Varo Believe may be able to help when you consistently make on-time payments.\n\n1Customers who had an existing credit score showed an average score increase of approximately 42 points after three months of having Varo Believe and no late payments on their credit. Individual results my vary.\n\nSome customers may not see an increase, but customers with bad or thin credit histories are likely to see the biggest positive impact on their score from using Varo Believe and making consistent on-time payments.Score increase is based on the VantageScore\n\n 3.0, a credit score alternative to the FICO score. VantageScore and FICO use different models and weigh factors differently when determining a credit score.',
    believeDay0TandC:
      'The Varo Believe Card is issued by Varo Bank, N.A. pursuant to a license from Visa USA, Inc.\n\nVaro Believe is a secured credit card designed to help you build credit; however, a variety of factors impact your credit and not all factors are equally weighted. You must add money before using, money added sets the spending limit. Funds spent are held in your Varo Believe Secured Account to pay off any balance in full monthly, when due. Quals apply.\n\nVaro provides access to your VantageScore 3.0 from TransUnion®. The VantageScore is a credit score alternative to the FICO score. VantageScore and FICO use different models and weigh factors differently when determining a credit score.\n\nAs of November 18th, 2024, customers who had an existing VantageScore® 3.0 credit score showed an average increase of approximately 40 points after three months using Varo Believe and on time payments. Individual results may vary, and some customers may not see a score increase.',
    addButton: 'Add money',
    believeDay0EligibilityText:
      'We will let you know when you become eligible. Quals apply.',
  },
  reviewPageString: {
    title: 'We’re reviewing your application',
    subtitle:
      'Sit tight for now. Once we take a look and make a decision, we’ll send an email letting you know.',
    doneButton: 'Done',
  },
  paymentDetails: {
    addMoneyText: 'Add money to pay in full',
    fullBalanceText:
      'You’ve spent more than you’ve set aside in your Account. There isn’t enough money to cover the full balance.',
    believeCardText:
      'Add money to your Secured Account so you can pay off your Varo Believe Card in full.',
    buttons: {
      addMoney: 'Add money',
      payPartially: 'Pay partially',
      payCard: 'Pay card',
      remindMeLater: 'Remind me later',
    },
  },
  makePayment: {
    payByCheck: {
      title: 'Pay by check',
      bullets: {
        one: 'Make your check payable to Varo Bank.',
        two: 'Include “Varo Believe Card payment” and the last four digits of your account number in the memo field.',
        three: 'Mail your check to:',
        threePoBox: '\nP.O. Box 108 \nDraper, UT 84020',
        four: 'Your check must arrive before 5:30 PM Eastern time on the day it’s due.',
        five: 'Be sure to write the last four digits of your Believe Card account number on your check; your account number’s last four digits can be found on your statement.',
        six: 'If payment is not honored for any reason you may be charged a Return Payment Fee of $15.',
      },
    },
    buttons: {
      payCard: 'Pay card',
      continue: 'Continue',
      cancel: 'Cancel',
      doneButton: 'Done',
      retry: 'Retry',
    },
    success: {
      niceJob: 'NICE JOB!',
      madePayment: 'YOU MADE A PAYMENT',
      madePaymentInfo:
        'This payment doesn’t change your available to spend amount. We move money from available to spend to secured fund when you use your card.',
    },
    error: {
      paymentFailed: 'Card payment failed',
      tryAgain: 'Please try again',
    },
    makePayment: 'Make a payment',
    howDoYouWantToPay: 'How do you want to pay?',
    payFromYourBelieveAccount: 'Pay from your Believe Account',
    ok: 'Ok',
    paymentProcessingTime: 'Payment processing times',
    paymentProcessingSchedule:
      'Payments from a non-Varo account can take up to 2 business days to process, depending on your bank’s processing schedule.',
    paymentFundText:
      ' The funds you previously set aside for payment will be available 3 business days after we receive your payment.',
    linkText: 'Learn more',
    paymentDate: 'Payment date',
    alertMessage_secured:
      'By scheduling this transfer from your Secured Account, you {{FULL_NAME}}, authorize Varo Bank, N.A. to apply a payment of {{PAYMENT_AMOUNT}} towards your Varo Believe. Payments will be processed immediately on scheduled date. You can cancel any scheduled transaction by going to Payment History before the day on which the payment is scheduled.',
    alertMessage_scheduled:
      '{{FULL_NAME}} authorizes Varo Bank, Inc. to arrange for a recurring payment of the statement balance as an ACH transfer from your bank account to Varo Bank on your Varo Believe Card. The withdrawal from the bank account you have designated generally happens within 2 business days of the scheduled payment date, but the exact time depends on your bank&rsquo;s processing schedule. You can cancel any scheduled transaction by going to Payment History before the day on which the payment is scheduled.',
    alertMessage_default:
      '{{FULL_NAME}} authorize Varo Bank, Inc. to arrange for a payment of {{PAYMENT_AMOUNT}} as an ACH transfer from your bank account to Varo Bank for payment of {{PAYMENT_AMOUNT}} on your Varo Believe. The withdrawal from the bank account you have designated generally happens within 2 business days of the scheduled payment date, but the exact time depends on your bank&rsquo;s processing schedule. You can cancel any scheduled transaction by going to Payment History before the day on which the payment is scheduled.',
  },
  moveYourPay: {
    headerTitle: 'Move Your Pay',
    description:
      'Automatically save a percentage of each direct deposit to your Believe Account. ',
    updateButtonLabel: 'Update',
    percentLimitMessage: 'You have {{existingPercentage}}% available to save',
    errorMessage: 'Your changes were not able to be saved. Please try again.',
    changesSavedMessage: 'Your changes have been saved',
    linkText: 'Learn More',
    directDepositSheet: {
      title: 'Set up direct deposit to automatically move your pay to Believe.',
      setUpButton: 'Set up direct deposit',
      skipButton: 'Skip for now',
    },
  },
};
